module.exports = __webpack_public_path__ + "img/40_69_004_740.84a60349.jpg";